import { useMemo } from "react";
import { useHospitalData } from "../../contexts/HospitalDataProvider";
import { hasHrisIntegrationOfType } from "../../utils/hrisIntegrations";

export const usePayrollConfirmation = (showActual: boolean) => {
	const { chosenDepartment } = useHospitalData();
	const hasShiftsIntegration = hasHrisIntegrationOfType(chosenDepartment, "shifts");

	return useMemo<boolean>(() => showActual && hasShiftsIntegration, [showActual, hasShiftsIntegration]);
};
